const PERMISSIONS_REPORT_PAGE = {
    VIEW: 'voucher_report_center::fulfillment',
} as const;

export default PERMISSIONS_REPORT_PAGE;